module.exports = __webpack_public_path__ + "static/media/4ODA16.34ff65b6.jpg";